import React, {
  useState,
  useEffect,
  useContext,
  useRef,
  useImperativeHandle,
  forwardRef,
} from "react";
import ReactDOM from "react-dom";
import Avatar from "@mui/material/Avatar";
import HorizontalTabs from "../Horizontal-Tabs/HorizontalTabs";
import CandidateInfo from "../../Components/Applicant-Tracking/Candidates/CandidateDetails/CandidateInfo";
import CandidateHistory from "../../Components/Applicant-Tracking/Candidates/CandidateDetails/CandidateHistory";
import CandidateDocuments from "../../Components/Applicant-Tracking/Candidates/CandidateDetails/CandidateDocuments";
import CandidateInterview from "../../Components/Applicant-Tracking/Candidates/CandidateDetails/CandidateInterview";
import RecommendedJobs from "../../Components/Applicant-Tracking/Candidates/CandidateDetails/RecommendedJobs";
import mailIcon from "../../Assets/Images/mail_icon.svg";
import phoneIcon from "../../Assets/Images/phone_icon.svg";
import locationIcon from "../../Assets/Images/location_icon.svg";
import experienceIcon from "../../Assets/Images/experience_icon.svg";
import {
  applyEllipsis,
  formatDate,
  roundUpExperience,
} from "../Common-Function/CommonFunctions";
import Button from "../../Common/Button/Button";
import { Toast } from "../../Common/Toast-Snackbar/ToastSnackbar";
import linkedInIcon from "../../Assets/Images/linkedinIcon.png";
import Badge from "@mui/material/Badge";
import { ReactComponent as UploadIcon } from "../../Assets/Images/profile-edit-icon.svg";
import ContentDialog from "../../Common/Content-Dialog/ContentDialog";
import BannerUploadIcon from "../../Assets/Images/banner-upload-icon.png";
import PlaceholderIcon from "../../Assets/Images/image-placeholder-loader.png";
import { Popupscroll } from "../../Common/Common-Function/CommonFunctions";
import { post, get, deleteRequest } from "../../helper/Api_helper";
import {
  VYLABS_BASE_URL,
  UPLOAD_CANDIDATE_IMAGE,
  GET_RECRUITER_BY_ID,
  GET_CANDIDATE_BY_ID,
  VENDORS_SEARCH,
  SEARC_JOBS,
  REACH_OUT_CANDIDATE_EMAIL,
  REACH_OUT_CANDIDATE_EMAIL_PREVIEW,
  CANDIDATES_REMOVE_IMAGE,
  TENANT_FIELD_DEFINITIONS_LIST,
} from "../../helper/url_helper";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import EditIcon from "@mui/icons-material/Edit";
import DownloadIcon from "@mui/icons-material/Download";
import DeleteIcon from "@mui/icons-material/Delete";
import { DynamicContext } from "../../Context/DynamicContext";
import TextInput from "../Textfield/Textfield";
import DynamicAutocomplete from "../AutoSuggestion/DynamicAutocomplete";
import TextArea from "../TextArea/TextArea";
import { toCapitalize } from "../Common-Function/CommonFunctions";
import ReachOutIcon from "../../Assets/Images/reach-out-icon.svg";
import EditCanIcon from "../../Assets/Images/edit-can-icon.svg";
import { StandardPopup } from "../../Common/PopupStyles/PopupComponent";
import EmailCampaignIcon from "../../Assets/Images/Email-campaign-icon.svg";
import SendJobBlastIcon from "../../Assets/Images/sendJobBlast.svg";
import { useFormik } from "formik";
import * as Yup from "yup";
import CustomTooltip from "../../Common/Tooltip/Tooltip";
import CandidateEditForm from "../../Components/Applicant-Tracking/Candidates/CandidateDetails/CandidateEditForm";
import EmailPreviewPopup from "../../Common/EmailPreviewPopup/EmailPreviewPopup";
import CropImage, { getCroppedImg } from "../Crop-Image/CropImage";
import { TENANT_CORE_API_KEY } from "../../Tenant-Config/TenantConfig";
import movedIcon from "../../Assets/Images/moved-icon.svg";
import movingIconProcessing from "../../Assets/Images/moving-icon-processing.svg";
import infoIcon from "../../Assets/Images/infoicon.svg";
import VybogtalProcessingAnimation from "../../Assets/Json/Vybogtal Processing Animation.json";
import VybogtalDoneAnimation from "../../Assets/Json/Vybogtal Done Animation.json";
import AnimationPlayer from "../Animation-Player/AnimationPlayer";
import OptionsData from "../../Assets/Json/StaticOptions.json";

const { StaticOptions = {} } = OptionsData || {};
const { industry: DEFAULT_INDUSTRY_OPTIONS = [] } = StaticOptions || {};

const CandidateDetailsContainer = forwardRef(
  (
    {
      candidate: initialCandidate,
      activeTab: propActiveTab,
      setActiveTab: propSetActiveTab,
      handleTabChange,
      hasSearched,
      hasRecommendedCandidates,
      onAssignJobClick,
      isEditingCandidate = false,
      handleEditCandidate = () => {},
      saveCandidateChanges = () => {},
      resetCandidateEdit = () => {},
      handleCandidateChange = () => {},
      editedCandidateData = null,
      hideSearchBox,
      assignedVendor,
      isRecommendedJobsLoading = false,
      showCandidateInfoTab = true,
      showCandidateHistoryTab = true,
      showCandidateDocumentsTab = true,
      showCandidateInterviewTab = true,
      showCandidateRecommendedJobsTab = true,
      showCandidateEmailHistoryTab = true,
      hasCandidateId = true,
      candidateId,
      industryOptions = DEFAULT_INDUSTRY_OPTIONS,
      failedDueToMissingData = false,
    },
    ref,
  ) => {
    const {
      isFromJobRecommendedCandidates,
      isVendorFeatureEnabled,
      userDetails,
      setUserDetails,
      isMonthlyEmailLimitReached,
      getMonthlyEmailTooltip,
      formatDateWithUserTimezone,
    } = useContext(DynamicContext);
    const [candidate, setCandidate] = useState(initialCandidate);
    const [avatarImage, setAvatarImage] = useState(
      initialCandidate?.avatar || null,
    );
    const [previewImage, setPreviewImage] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [isCropMode, setIsCropMode] = useState(false);
    const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
    const [vendorList, setVendorList] = useState([]);
    const [vendorOptionLoading, setVendorOptionLoading] = useState(false);
    const [candidateCreatedUserName, setCandidateCreatedUserName] =
      useState("Loading...");
    const [activeTab, setActiveTab] = useState(propActiveTab || 0);
    const realSetActiveTab = propSetActiveTab || setActiveTab;
    const [isReachOutPopupOpen, setIsReachOutPopupOpen] = useState(false);
    const [reachOutJobListOptions, setReachOutJobListOptions] = useState([]);
    const [reachOutJobOptionLoading, setReachOutJobOptionLoading] =
      useState(false);
    const [isEmailPreviewOpen, setIsEmailPreviewOpen] = useState(false);
    const [emailPreviewData, setEmailPreviewData] = useState({
      body: "",
      subject: "",
      isLoading: false,
    });
    const [candidateCustomFields, setCandidateCustomFields] = useState([]);
    const reachOutMessageWrapperRef = useRef(null);
    const reachOutFormik = useFormik({
      initialValues: {
        subject: "",
        message: "",
        selectedJob: null,
      },
      validationSchema: Yup.object({
        subject: Yup.string().required("Subject is required"),
        message: Yup.string().required("Message is required"),
      }),
      onSubmit: async (values) => {
        if (isMonthlyEmailLimitReached) {
          Toast(
            "error",
            "Monthly email limit reached. Please upgrade your plan.",
          );
          return;
        }

        try {
          const payload = {
            candidate_id: candidate.id,
            message: values.message,
            subject: values.subject,
          };
          if (values.selectedJob?.value) {
            payload.job_id = values.selectedJob.value;
          }
          await post(VYLABS_BASE_URL, REACH_OUT_CANDIDATE_EMAIL, payload);
          Toast("success", "Email sent successfully");
          handleCloseReachOutPopup();
        } catch (error) {
          console.error("Error sending reach out email:", error);
          Toast(
            "error",
            error.message || "Failed to send email. Please try again.",
          );
        }
      },
    });

    useImperativeHandle(
      ref,
      () => ({
        openReachOut: () => {
          if (isMonthlyEmailLimitReached) {
            Toast(
              "error",
              "Monthly email limit reached. Please upgrade your plan.",
            );
            return;
          }

          setIsReachOutPopupOpen(true);
        },
      }),
      [isMonthlyEmailLimitReached],
    );

    useEffect(() => {
      if (isReachOutPopupOpen) {
        const textarea =
          reachOutMessageWrapperRef.current?.querySelector("textarea");
        if (textarea) {
          textarea.style.height = "auto";
          textarea.style.height = `${textarea.scrollHeight}px`;
        }
      }
    }, [reachOutFormik.values.message, isReachOutPopupOpen]);

    useEffect(() => {
      setCandidate(initialCandidate);
    }, [initialCandidate]);

    useEffect(() => {
      const fetchCandidateDetails = async () => {
        if (
          initialCandidate?.shouldSkipFetch ||
          initialCandidate?.isTemp ||
          (initialCandidate?.id && initialCandidate.id.startsWith("temp_dice_"))
        ) {
          setIsLoading(false);
          return;
        }

        if (
          initialCandidate &&
          initialCandidate.id &&
          !initialCandidate.id.startsWith("temp_monster_")
        ) {
          setIsLoading(true);
          try {
            const res = await get(
              VYLABS_BASE_URL,
              `${GET_CANDIDATE_BY_ID}?id=${initialCandidate.id}`,
            );
            const fetchedCandidate = res?.candidate;
            const candidatefiles = res?.files;
            const parsedResumeData = fetchedCandidate?.parsed_resume
              ? JSON.parse(fetchedCandidate.parsed_resume)
              : null;

            const updatedCandidate = {
              ...fetchedCandidate,
              secondaryEmail: fetchedCandidate.secondary_email,
              secondaryPhone: fetchedCandidate.secondary_phone,
              vendorID: fetchedCandidate.vendor_id,
              parsedResumeData,
              files: candidatefiles || null,
              avatar: res?.profile_img_url,
              experience: fetchedCandidate.years_of_experience,
            };
            setCandidate((prev) => ({
              ...updatedCandidate,
              recommendedJobs:
                prev?.recommendedJobs?.length > 0
                  ? prev.recommendedJobs
                  : initialCandidate?.recommendedJobs,
            }));
          } catch (error) {
            console.error("Error fetching candidate details:", error);
            Toast("error", "Failed to fetch candidate details.");
          } finally {
            setIsLoading(false);
          }
        } else {
          setIsLoading(false);
        }
      };
      fetchCandidateDetails();
    }, [
      initialCandidate?.id,
      initialCandidate?.isTemp,
      initialCandidate?.shouldSkipFetch,
    ]);

    useEffect(() => {
      const fetchUserDetails = async () => {
        if (!candidate?.user_id) {
          setIsLoading(false);
          setCandidateCreatedUserName("Loading...");
          return;
        }
        try {
          setIsLoading(true);
          const response = await get(
            VYLABS_BASE_URL,
            `${GET_RECRUITER_BY_ID}?id=${candidate?.user_id}`,
          );
          if (response?.user) {
            setCandidateCreatedUserName(
              `${response?.user?.first_name} ${response?.user?.last_name}`,
            );
          }
        } catch (error) {
          console.error("Error fetching user details:", error);
          setCandidateCreatedUserName("Unknown");
        } finally {
          setIsLoading(false);
        }
      };

      fetchUserDetails();
    }, [candidate?.user_id]);

    useEffect(() => {
      if (candidate?.avatar) {
        setAvatarImage(candidate.avatar);
        setIsLoading(false);
      } else {
        setIsLoading(false);
      }
    }, [candidate?.avatar]);

    useEffect(() => {
      if (isEditingCandidate && activeTab !== 0) {
        realSetActiveTab(0);
      }
    }, [isEditingCandidate, activeTab, realSetActiveTab]);

    useEffect(() => {
      if (
        isFromJobRecommendedCandidates &&
        activeTab === "Recommended Candidates"
      ) {
        realSetActiveTab("Job Details");
      }
    }, [isFromJobRecommendedCandidates, activeTab, realSetActiveTab]);

    useEffect(() => {
      if (typeof propActiveTab === "number" && propActiveTab !== activeTab) {
        setActiveTab(propActiveTab);
      }
    }, [propActiveTab]);

    const getTabNames = (candidate) => {
      const tabs = [];

      if (showCandidateInfoTab) tabs.push({ name: "Info" });
      if (showCandidateHistoryTab) tabs.push({ name: "History" });
      if (showCandidateDocumentsTab) tabs.push({ name: "Documents" });
      if (showCandidateInterviewTab) tabs.push({ name: "Interview Scheduler" });
      const shouldShowRecommendedJobs =
        showCandidateRecommendedJobsTab &&
        !hasSearched &&
        !hasRecommendedCandidates &&
        !isFromJobRecommendedCandidates;

      if (shouldShowRecommendedJobs) {
        tabs.push({ name: "Recommended Jobs" });
      }
      return tabs;
    };

    useEffect(() => {
      const tabs = getTabNames(candidate);
      if (activeTab >= tabs.length) {
        realSetActiveTab(0);
      }
    }, [isFromJobRecommendedCandidates, candidate, activeTab]);

    useEffect(() => {
      if (candidate) {
        fetchCustomFields();
      }
    }, [candidate]);

    const onCropComplete = React.useCallback(
      (croppedArea, croppedAreaPixels) => {
        setCroppedAreaPixels(croppedAreaPixels);
      },
      [],
    );

    if (!candidate) {
      return <div>No candidate selected.</div>;
    }

    const fetchEmailPreview = async () => {
      const { subject, message, selectedJob } = reachOutFormik.values;
      if (!subject?.trim() || !message?.trim()) {
        Toast("warning", "Please fill in subject and message before preview");
        return;
      }
      setEmailPreviewData((prev) => ({ ...prev, isLoading: true }));

      try {
        const payload = {
          candidate_id: candidate.id,
          message: message,
          subject: subject,
        };
        if (selectedJob?.value) {
          payload.job_id = selectedJob.value;
        }

        const response = await post(
          VYLABS_BASE_URL,
          REACH_OUT_CANDIDATE_EMAIL_PREVIEW,
          payload,
        );

        if (response) {
          setEmailPreviewData({
            body: response.body || "",
            subject: response.subject || subject,
            isLoading: false,
          });
          setIsEmailPreviewOpen(true);
        }
      } catch (error) {
        console.error("Error fetching email preview:", error);
        Toast("error", error.message || "Failed to load email preview");
        setEmailPreviewData((prev) => ({ ...prev, isLoading: false }));
      }
    };

    const formatLinkedInUrl = (url) => {
      if (!url) return null;
      return url.startsWith("http") ? url : `https://${url}`;
    };

    const handleOpenMenu = (event) => {
      setAnchorEl(event.currentTarget);
    };

    const handleCloseMenu = () => {
      setAnchorEl(null);
    };

    const handleOpenModal = () => {
      setPreviewImage(null);
      setIsModalOpen(true);
      handleCloseMenu();
    };

    const handleDeleteImage = async () => {
      try {
        await deleteRequest(
          VYLABS_BASE_URL,
          `${CANDIDATES_REMOVE_IMAGE}?candidate_id=${candidate.id}`,
        );
        setAvatarImage(null);

        setUserDetails((prev) => ({
          ...prev,
          profile_img_url: null,
        }));
        Toast("success", "Image deleted successfully");
        handleCloseMenu();
      } catch (error) {
        console.error("Error deleting image:", error);
        Toast("error", "Failed to delete image");
      }
    };

    const fetchVendors = async (inputValue = "") => {
      try {
        setVendorOptionLoading(true);
        const response = await get(
          VYLABS_BASE_URL,
          `${VENDORS_SEARCH}?vendor_name=${encodeURIComponent(inputValue)}`,
        );

        const { vendors = [] } = response;
        const fetchedVendors = Array.isArray(vendors)
          ? vendors
              .filter((v) => v?.id && v?.name)
              .map((v) => ({
                label: v.contact_person
                  ? `${v.name} - ${v.contact_person}`
                  : v.name,
                value: v.id,
              }))
          : [];

        setVendorList(fetchedVendors);
      } catch (err) {
        console.error("fetchVendors error", err);
        setVendorList([]);
      } finally {
        setVendorOptionLoading(false);
      }
    };

    const handleVendorInputChange = (_, value) => {
      if (value && value.length >= 3) {
        fetchVendors(value);
      } else {
        setVendorList([]);
      }
    };

    const handleUploadImage = async () => {
      let fileToUpload = previewImage;

      if (fileToUpload instanceof File && croppedAreaPixels) {
        try {
          const imageSrc = URL.createObjectURL(fileToUpload);
          const croppedBlob = await getCroppedImg(imageSrc, croppedAreaPixels);
          fileToUpload = new File(
            [croppedBlob],
            previewImage.name || "candidate.jpg",
            {
              type: previewImage.type,
            },
          );
          URL.revokeObjectURL(imageSrc);
        } catch (error) {
          console.error("Crop error:", error);
          Toast("error", "Failed to crop image");
          return;
        }
      }

      if (fileToUpload instanceof File) {
        const formData = new FormData();
        formData.append("file", fileToUpload);
        formData.append("candidate_id", candidate?.id);

        post(VYLABS_BASE_URL, UPLOAD_CANDIDATE_IMAGE, formData)
          .then((response) => {
            const newImageUrl =
              response.profile_img_url || URL.createObjectURL(fileToUpload);
            setAvatarImage(newImageUrl);
            setIsModalOpen(false);
            setIsCropMode(false);
            setPreviewImage(null);
            Toast("success", "Candidate Image uploaded successfully");
          })
          .catch((error) => {
            Toast("error", "Failed to upload image");
            console.error("Upload error:", error);
          });
      } else {
        Toast("warning", "Please select a valid image file to upload");
      }
    };

    const handleFileUpload = (file) => {
      const allowedTypes = ["image/jpeg", "image/png", "image/jpg"];
      if (!allowedTypes.includes(file.type)) {
        Toast(
          "warning",
          "Invalid file type. Only JPG, JPEG, or PNG are allowed.",
        );
        return;
      }
      if (file.size > 5 * 1024 * 1024) {
        Toast("warning", "Please upload an image less than 5MB.");
        return;
      }
      setPreviewImage(file);
      setIsCropMode(true);
    };

    const handleSelectFile = (event) => {
      const file = event.target.files[0];
      if (file) {
        handleFileUpload(file);
      } else {
        Toast("warning", "No file selected. Please try again.");
      }
    };

    const handleDrop = (event) => {
      event.preventDefault();
      const file = event.dataTransfer.files[0];
      if (file) {
        handleFileUpload(file);
      }
    };

    const handleDragOver = (event) => {
      event.preventDefault();
    };

    const handleDownloadImage = () => {
      if (avatarImage) {
        const link = document.createElement("a");
        link.href = avatarImage;
        const candidateName =
          candidate?.name || candidate?.BasicInfo?.Name || "candidate";
        const safeName = candidateName
          .trim()
          .replace(/[\\/:*?"<>|]+/g, "")
          .replace(/\s+/g, "_");

        link.download = `${safeName}.jpg`;
        link.target = "_blank";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        handleCloseMenu();
      } else {
        Toast("warning", "No avatar image available to download");
        handleCloseMenu();
      }
    };

    const handleCandidateDataUpdate = (updatedCandidate) => {
      setCandidate((prev) => ({
        ...prev,
        ...updatedCandidate,
      }));
    };
    const handleReachOutClick = () => {
      setIsReachOutPopupOpen(true);
    };

    const handleCloseReachOutPopup = () => {
      setIsReachOutPopupOpen(false);
      reachOutFormik.resetForm();
      setReachOutJobListOptions([]);
    };

    const handleReachOutJobInputChange = async (_, value) => {
      if (value && value.length >= 3) {
        fetchReachOutJobOptions(value);
      } else if (!value) {
        setReachOutJobListOptions([]);
      }
    };

    const fetchReachOutJobOptions = async (inputValue) => {
      if (!inputValue) return;
      setReachOutJobOptionLoading(true);
      try {
        const response = await post(VYLABS_BASE_URL, SEARC_JOBS, {
          query: inputValue,
        });
        const data = response.jobs || [];
        const fetchOptions = [
          ...new Map(
            data.map((item) => [
              item.id,
              { label: item.title, value: item.id },
            ]),
          ).values(),
        ];
        setReachOutJobListOptions(fetchOptions);
      } catch (error) {
        console.error("Error fetching jobs:", error);
      } finally {
        setReachOutJobOptionLoading(false);
      }
    };

    Popupscroll(isModalOpen);
    const renderTabContent = () => {
      const tabs = getTabNames(candidate);
      const activeTabName = tabs[activeTab]?.name;

      const tabComponents = {
        Info: (
          <CandidateInfo
            candidate={candidate}
            isEditingCandidate={isEditingCandidate}
            handleCandidateChange={handleCandidateChange}
            editedCandidateData={editedCandidateData}
            vendorList={vendorList}
            vendorOptionLoading={vendorOptionLoading}
            handleVendorInputChange={handleVendorInputChange}
            assignedVendor={assignedVendor}
            isVendorFeatureEnabled={isVendorFeatureEnabled}
            candidateCustomFields={candidateCustomFields}
          />
        ),
        History: (
          <CandidateHistory
            candidate={candidate}
            handleTabChange={handleTabChange}
            onAssignJobClick={onAssignJobClick}
            hasSearched={hasSearched}
            candidateId={candidateId}
          />
        ),
        Documents: (
          <CandidateDocuments
            candidate={candidate}
            onCandidateUpdate={handleCandidateDataUpdate}
          />
        ),
        "Interview Scheduler": <CandidateInterview candidate={candidate} />,
        "Recommended Jobs": (
          <RecommendedJobs
            candidate={candidate}
            CandidatehasSearched={hasSearched}
            hideSearchBox={hideSearchBox}
            isRecommendedJobsLoading={isRecommendedJobsLoading}
          />
        ),
      };

      return (
        tabComponents[activeTabName] || (
          <div>No content available for this candidate.</div>
        )
      );
    };
    const accessJobBlastPreview = () => {
      const { subject, message } = reachOutFormik.values;
      const hasSubject =
        typeof subject === "string" && subject.trim().length > 0;
      const hasMessage =
        typeof message === "string" && message.trim().length > 0;
      return hasSubject && hasMessage;
    };
    const canPreview = accessJobBlastPreview();
    const fetchCustomFields = async () => {
      try {
        const response = await get(
          VYLABS_BASE_URL,
          `${TENANT_FIELD_DEFINITIONS_LIST}?entity_type=candidate`,
          {
            headers: {
              "X-API-Key": TENANT_CORE_API_KEY,
            },
          },
        );
        if (response?.definitions) {
          const definitions = response.definitions;
          const customFields = candidate?.custom_fields || {};
          const isTopLevelIndustryField = (field) => {
            const normalizedKey = String(field.field_key || "").toLowerCase();
            const normalizedLabel = String(field.label || "").toLowerCase();
            return (
              normalizedKey === "industry" || normalizedLabel === "industry"
            );
          };
          const matchedFields = definitions
            .filter((field) => !isTopLevelIndustryField(field))
            .map((field) => ({
              ...field,
              value: customFields[field.field_key] || "",
            }))
            .filter((field) => field.value !== undefined)
            .sort((a, b) => {
              if (a.field_type === "boolean" && b.field_type !== "boolean")
                return 1;
              if (a.field_type !== "boolean" && b.field_type === "boolean")
                return -1;
              return 0;
            });
          setCandidateCustomFields(matchedFields);
        }
      } catch (error) {
        console.error("error in fetchFields:", error);
      }
    };

    return (
      <div
        className="candidate-details-wrapper"
        style={{
          height: "100%",
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
        }}
      >
        <div className="client-details-new-outer sticky-header">
          <div
            className="candidate-details-new"
            style={{ display: "flex", flexDirection: "column", gap: "15px" }}
          >
            <div
              className="candidate-avatar-name"
              style={{ display: "flex", alignItems: "center", gap: "15px" }}
            >
              <div
                className="candidate-name-container"
                style={{ display: "flex", alignItems: "center", gap: "10px" }}
              >
                <Badge
                  overlap="circular"
                  anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "right",
                  }}
                  style={{ cursor: "pointer" }}
                  badgeContent={<UploadIcon className="edit-icon" />}
                  onClick={handleOpenMenu}
                >
                  <Avatar
                    alt={candidate.name || candidate.BasicInfo?.Name || "N/A"}
                    src={isLoading ? PlaceholderIcon : avatarImage}
                    sx={{ width: 50, height: 50 }}
                  />
                </Badge>
                <Menu
                  anchorEl={anchorEl}
                  open={Boolean(anchorEl)}
                  onClose={handleCloseMenu}
                  anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "right",
                  }}
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "right",
                  }}
                  PaperProps={{
                    sx: {
                      backgroundColor: "#f5f5f5",
                      borderRadius: "8px",
                      boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                    },
                  }}
                >
                  <MenuItem
                    onClick={handleOpenModal}
                    sx={{
                      "&:hover": {
                        backgroundColor: "#e0e0e0",
                      },
                    }}
                  >
                    <ListItemIcon>
                      <EditIcon fontSize="small" />
                    </ListItemIcon>
                    {avatarImage ? "Edit Image" : "Upload Image"}
                  </MenuItem>
                  {avatarImage && (
                    <MenuItem
                      onClick={handleDownloadImage}
                      sx={{
                        "&:hover": {
                          backgroundColor: "#e0e0e0",
                        },
                      }}
                    >
                      <ListItemIcon>
                        <DownloadIcon fontSize="small" />
                      </ListItemIcon>
                      Download Image
                    </MenuItem>
                  )}

                  {avatarImage && (
                    <MenuItem
                      onClick={handleDeleteImage}
                      sx={{
                        "&:hover": {
                          backgroundColor: "#e0e0e0",
                        },
                      }}
                    >
                      <ListItemIcon>
                        <DeleteIcon fontSize="small" />
                      </ListItemIcon>
                      Remove Image
                    </MenuItem>
                  )}
                </Menu>
                <div className="candidate-name">
                  {applyEllipsis(
                    toCapitalize(
                      candidate.name || candidate.BasicInfo?.Name || "N/A",
                      40,
                    ),
                  )}
                </div>
                {candidate?.parsedResumeData?.BasicInfo
                  ?.LinkedInWebsiteLink && (
                  <a
                    href={formatLinkedInUrl(
                      candidate?.parsedResumeData?.BasicInfo
                        ?.LinkedInWebsiteLink,
                    )}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ textDecoration: "none" }}
                  >
                    <img src={linkedInIcon} alt="linkedInIcon" />
                  </a>
                )}
                {!hasCandidateId && !failedDueToMissingData ? (
                  <CustomTooltip
                    arrow
                    placement="bottom"
                    pill={false}
                    title={
                      <div className="move-status-tooltip">
                        <div className="move-status-tooltip-title">
                          Importing
                        </div>
                        <div className="move-status-tooltip-description">
                          This candidate is from IRMT and is being moved to
                          Vybogtal. You cannot make changes here.
                        </div>
                      </div>
                    }
                  >
                    <div className="move-status-badge moving">
                      <AnimationPlayer
                        animationSrc={VybogtalProcessingAnimation}
                        playerWidth="30px"
                        playerHeight="30px"
                      />
                      <span>Importing</span>
                      <img src={infoIcon} alt="infoIcon" />
                    </div>
                  </CustomTooltip>
                ) : hasCandidateId && candidateId && !failedDueToMissingData ? (
                  <CustomTooltip
                    arrow
                    placement="bottom"
                    pill={false}
                    title={
                      <div className="move-status-tooltip">
                        <div className="move-status-tooltip-title">
                          Import Complete
                        </div>
                        <div className="move-status-tooltip-description">
                          This candidate has been successfully moved to
                          Vybogtal. You can now make changes and add tracking
                          history.
                        </div>
                      </div>
                    }
                  >
                    <div className="move-status-badge moved">
                      <AnimationPlayer
                        animationSrc={VybogtalDoneAnimation}
                        playerWidth="30px"
                        playerHeight="30px"
                      />
                      <span>Import Complete</span>
                      <img src={infoIcon} alt="infoIcon" />
                    </div>
                  </CustomTooltip>
                ) : failedDueToMissingData ? (
                  <CustomTooltip
                    arrow
                    placement="bottom"
                    pill={false}
                    title={
                      <div className="move-status-tooltip">
                        <div className="move-status-tooltip-title">
                          Failed to Import
                        </div>
                        <div className="move-status-tooltip-description">
                          This candidate failed to move to Vybogtal because
                          their email, phone number, or resume file is missing.
                        </div>
                      </div>
                    }
                  >
                    <div className="move-status-badge notmoved">
                      <span>Failed to Import</span>
                      <img src={infoIcon} alt="infoIcon" />
                    </div>
                  </CustomTooltip>
                ) : null}
              </div>
              {hasCandidateId && (
                <div className="create-update-details">
                  {!candidate.isFileBased && (
                    <div className="company-dates">
                      <span>
                        Created at :{" "}
                        {formatDateWithUserTimezone(candidate.created_at) ||
                          "N/A"}
                      </span>
                      <span>
                        Updated at :{" "}
                        {formatDateWithUserTimezone(candidate.updated_at) ||
                          "N/A"}
                      </span>
                    </div>
                  )}
                  {userDetails?.tenant_id ===
                  "8d01a95f87c7465a9b11998555631f66" ? null : (
                    <div className="company-dates">
                      {" "}
                      <span>Created By : {candidateCreatedUserName}</span>
                    </div>
                  )}
                </div>
              )}
            </div>
            <div className="candidate-info-outer-container">
              <div className="candidate-information">
                <div className="info-header">
                  <img
                    alt="mailIcon"
                    src={mailIcon}
                    style={{ width: "20px", height: "20px" }}
                    className="info-icon"
                  />
                  <h4 className="info-header-value">Email</h4>
                </div>
                <div className="candidate-email">
                  {candidate.email || candidate.BasicInfo?.Email || "N/A"}
                </div>
              </div>
              <div className="candidate-information">
                <div className="info-header">
                  <img
                    src={phoneIcon}
                    alt="phoneIcon"
                    style={{ width: "20px", height: "20px" }}
                    className="info-icon"
                  />
                  <h4 className="info-header-value">Contact No.</h4>
                </div>
                <div className="candidate-phone">
                  {candidate.phone || candidate.BasicInfo?.PhoneNumber || "N/A"}
                </div>
              </div>
              <div className="candidate-information">
                <div className="info-header">
                  <img
                    src={locationIcon}
                    alt="locationIcon"
                    style={{ width: "20px", height: "20px" }}
                    className="info-icon"
                  />
                  <h4 className="info-header-value">Location</h4>
                </div>
                <div className="candidate-url">
                  {[
                    candidate.city ||
                      candidate.BasicInfo?.CurrentLocationCity ||
                      "N/A",
                    candidate.state ||
                      candidate.BasicInfo?.CurrentLocationState ||
                      "",
                    candidate.country ||
                      candidate.BasicInfo?.CurrentLocationCountry ||
                      "",
                  ]
                    .filter((val) => val && val.trim() !== "")
                    .join(", ")}
                </div>
              </div>
              <div className="candidate-information">
                <div className="info-header">
                  <img
                    src={experienceIcon}
                    alt="experienceIcon"
                    style={{ width: "20px", height: "20px" }}
                    className="info-icon"
                  />
                  <h4 className="info-header-value">Experience</h4>
                </div>

                <div className="candidate-email">
                  {roundUpExperience(
                    candidate.experience ??
                      candidate.years_of_experience ??
                      candidate.parsedResumeData?.BasicInfo?.YearsOfExperience,
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          className="candidate-tabs-container"
          style={{
            marginBottom: "-8px",
            marginLeft: "10px",
          }}
        >
          <HorizontalTabs
            activeTab={activeTab}
            handleTabChange={(index) => {
              if (!hasCandidateId && !failedDueToMissingData) {
                Toast(
                  "warning",
                  "Please wait until the candidate is completely created in VybogTAL",
                );
                return;
              } else if (failedDueToMissingData) {
                Toast("error", "Failed to create candidate in VybogTAL");
                return;
              }
              if (isEditingCandidate && index !== 0) {
                Toast(
                  "warning",
                  "Please save or cancel your changes before switching tabs",
                );
                return;
              }
              realSetActiveTab(index);
            }}
            tabNames={getTabNames(candidate)}
            containerStyle={{ width: "100%" }}
            tabstyle={{
              borderRadius: "10px 10px 0 0",
              marginBottom: "10px",
            }}
            tabBorderBottom="0"
          />
        </div>
        <div
          className="tab-content"
          style={{
            flex: 1,
            overflowY: "auto",
            padding: "20px",
            scrollbarGutter: "stable",
          }}
        >
          {isEditingCandidate ? (
            <div
              style={{
                animation:
                  "fadeSlideUp 600ms cubic-bezier(0.22, 1, 0.36, 1) both",
                willChange: "transform, opacity",
              }}
            >
              <style>
                {`
                @keyframes fadeSlideUp {
                  from {
                    opacity: 0;
                    transform: translateY(10px);
                  }
                  to {
                    opacity: 1;
                    transform: translateY(0);
                  }
                }
              `}
              </style>
              <CandidateEditForm
                candidate={candidate}
                editedCandidateData={editedCandidateData}
                handleCandidateChange={handleCandidateChange}
                candidateCustomFields={candidateCustomFields}
                vendorList={vendorList}
                vendorOptionLoading={vendorOptionLoading}
                handleVendorInputChange={handleVendorInputChange}
                assignedVendor={assignedVendor}
                isVendorFeatureEnabled={isVendorFeatureEnabled}
                industryOptions={industryOptions}
              />
            </div>
          ) : (
            renderTabContent()
          )}
        </div>
        <ContentDialog
          isOpen={isModalOpen}
          onClose={() => setIsModalOpen(false)}
          onCloseIconClose={() => setIsModalOpen(false)}
          submitButtonLabel="Upload"
          cancelButtonLabel={"Cancel"}
          showActionButton={!!previewImage}
          event={handleUploadImage}
          contentWidth="40vw"
          overflowY={true}
          contentHeight="60vh"
          title={
            previewImage
              ? "Candidate Profile Image Preview"
              : "Upload Candidate Image"
          }
        >
          <div>
            {previewImage ? (
              <>
                <div className="preview-container">
                  <div
                    style={{
                      width: "200px",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: "10px",
                    }}
                  >
                    <CropImage
                      image={previewImage}
                      onCropComplete={onCropComplete}
                    />
                  </div>
                </div>
                <div className="info-container">
                  <span className="info-span">
                    Save your candidate profile image by clicking "Upload"
                    below.
                  </span>
                </div>
              </>
            ) : (
              <>
                <div
                  className="profile-image-container"
                  onDrop={handleDrop}
                  onDragOver={handleDragOver}
                >
                  <img
                    src={BannerUploadIcon}
                    alt="BannerUploadIcon"
                    className="banner-upload-icon"
                  />
                  <span className="upload-text">
                    Drag and drop images to upload
                  </span>
                  <div className="upload-button-container">
                    <label htmlFor="file-input-candidate">
                      <Button
                        label="Select files"
                        backgroundColor="#fff"
                        color="#000"
                        border="1px solid #ccc"
                        event={() =>
                          document
                            .getElementById("file-input-candidate")
                            .click()
                        }
                      />
                    </label>
                    <input
                      id="file-input-candidate"
                      type="file"
                      accept="image/jpeg, image/png, image/gif"
                      style={{ display: "none" }}
                      onChange={(e) => handleSelectFile(e)}
                    />
                  </div>
                </div>
                <div className="info-container">
                  <span className="info-span">
                    JPG,JPEG,PNG Files are Allowed, Max Size 5MB.
                  </span>
                </div>
              </>
            )}
          </div>
        </ContentDialog>
        <StandardPopup
          isOpen={isReachOutPopupOpen}
          onClose={handleCloseReachOutPopup}
          title={
            <div
              style={{ display: "flex", gap: "10px", alignItems: "flex-start" }}
            >
              <img
                src={EmailCampaignIcon}
                alt="email-icon"
                style={{ marginTop: "4px" }}
              />
              <div style={{ display: "flex", flexDirection: "column" }}>
                <span
                  style={{
                    color: "var(--text_color)",
                    fontSize: "18px",
                    fontWeight: "600",
                    lineHeight: "1.2",
                  }}
                >
                  Reach Out to Candidate
                </span>
                <span
                  style={{
                    color: "#6B7280",
                    fontSize: "12px",
                    fontWeight: "400",
                    marginTop: "4px",
                  }}
                >
                  Send email to{" "}
                  {candidate?.name ||
                    candidate?.BasicInfo?.Name ||
                    "Tristin Liton"}
                </span>
              </div>
            </div>
          }
          hideActions={true}
          width="500px"
          popupStyle={{}}
          headerStyle={{ backgroundColor: "var(--body__background)" }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "15px",
              width: "100%",
            }}
          >
            <div style={{ display: "flex", gap: "20px" }}>
              <div style={{ flex: 1 }}>
                <label
                  style={{
                    display: "block",
                    color: "var(--text_color)",
                    marginBottom: "5px",
                    fontSize: "14px",
                    fontWeight: "500",
                  }}
                >
                  From
                </label>
                <div style={{ color: "#6B7280", fontSize: "14px" }}>
                  {userDetails?.email}
                </div>
              </div>
              <div style={{ flex: 1 }}>
                <label
                  style={{
                    display: "block",
                    color: "var(--text_color)",
                    marginBottom: "5px",
                    fontSize: "14px",
                    fontWeight: "500",
                  }}
                >
                  To
                </label>
                <div style={{ color: "#6B7280", fontSize: "14px" }}>
                  {candidate?.email ||
                    candidate?.BasicInfo?.Email ||
                    "tristin.liton@example.com"}
                </div>
              </div>
            </div>
            <div>
              <label
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                  color: "var(--text_color)",
                  marginBottom: "5px",
                  fontSize: "14px",
                  fontWeight: "500",
                }}
              >
                <span>Select Job</span>
              </label>
              <DynamicAutocomplete
                placeholder="Search jobs..."
                options={reachOutJobListOptions}
                value={reachOutFormik.values.selectedJob}
                onChange={(val) =>
                  reachOutFormik.setFieldValue("selectedJob", val)
                }
                onInputChange={handleReachOutJobInputChange}
                loading={reachOutJobOptionLoading}
                onBlur={() =>
                  reachOutFormik.setFieldTouched("selectedJob", true)
                }
                error={
                  reachOutFormik.touched.selectedJob &&
                  Boolean(reachOutFormik.errors.selectedJob)
                }
                errorMessage={""}
                sx={{
                  mt: "5px",
                  ".MuiOutlinedInput-root": {
                    borderRadius: "12px",
                    height: "40px",
                    "& .MuiOutlinedInput-notchedOutline": {
                      border: "1px solid var(--border__color) !important",
                      borderRadius: "12px",
                    },
                    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                      borderColor: "#6860ee",
                      borderRadius: "12px",
                    },
                    "&:hover .MuiOutlinedInput-notchedOutline": {
                      borderColor: "#7a70f2",
                      borderRadius: "12px",
                    },
                  },
                  ".MuiInputBase-input": {
                    color: "var(--header__color)",
                    padding: "8px 12px !important",
                    height: "40px",
                    fontFamily: "Satoshi !important",
                  },
                }}
                slotProps={{
                  paper: {
                    sx: {
                      backgroundColor: "var(--body__background)",
                      color: "var(--header__color)",
                      borderRadius: "12px",
                      boxShadow: "0px 4px 20px rgba(0,0,0,0.1)",
                      border: "1px solid var(--header__color)",
                    },
                  },
                  listbox: {
                    sx: {
                      "& li": {
                        fontSize: "14px",
                        fontWeight: 500,
                        padding: "8px 16px",
                        color: "var(--header__color)",
                        "&:hover": {
                          backgroundColor: "rgba(0,0,0,0.04)",
                        },
                      },
                    },
                  },
                }}
              />
              {reachOutFormik.touched.selectedJob &&
                reachOutFormik.errors.selectedJob && (
                  <div
                    style={{
                      color: "red",
                      fontSize: "16px",
                      marginBottom: "6px",
                      textAlign: "left",
                    }}
                  >
                    {reachOutFormik.errors.selectedJob}
                  </div>
                )}
              <span
                style={{
                  fontSize: "12px",
                  color: "#6B7280",
                  fontStyle: "italic",
                }}
              >
                An invitation to apply to this job will be included in the email
              </span>
            </div>
            <span>
              Subject <span className="required-asterisk">*</span>
            </span>
            <TextInput
              name="subject"
              labelStyle={{ color: "var(--text_color)", marginBottom: "-6px" }}
              value={reachOutFormik.values.subject}
              placeholder="e.g. Job Opportunity"
              onChange={reachOutFormik.handleChange}
              onBlur={reachOutFormik.handleBlur}
              error={
                reachOutFormik.touched.subject &&
                Boolean(reachOutFormik.errors.subject)
              }
              errorMessage={reachOutFormik.errors.subject}
              style={{
                color: "var(--header__color)",
                border: "1px solid var(--border__color)",
              }}
            />
            <div ref={reachOutMessageWrapperRef}>
              <TextArea
                label={
                  <span>
                    Message <span className="required-asterisk">*</span>
                  </span>
                }
                name="message"
                labelStyle={{ color: "var(--text_color)" }}
                placeholder="Enter the candidate email message "
                value={reachOutFormik.values.message}
                onChange={reachOutFormik.handleChange}
                onBlur={reachOutFormik.handleBlur}
                style={{
                  color: "var(--header__color)",
                  border: "1px solid var(--border__color)",
                  overflow: "hidden",
                  resize: "none",
                }}
                rows={4}
              />
              {reachOutFormik.touched.message &&
                reachOutFormik.errors.message && (
                  <div
                    style={{
                      color: "red",
                      fontSize: "12px",
                      marginTop: "4px",
                      marginLeft: "14px",
                    }}
                  >
                    {reachOutFormik.errors.message}
                  </div>
                )}
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                gap: "10px",
                marginTop: "20px",
              }}
            >
              <Button
                label="Cancel"
                event={handleCloseReachOutPopup}
                isCancel={true}
                style={{ marginRight: "0px" }}
              />
              <CustomTooltip
                title={canPreview ? "Click to view preview" : ""}
                arrow
              >
                <span>
                  <Button
                    label={
                      emailPreviewData.isLoading
                        ? "Loading..."
                        : "Email Preview"
                    }
                    event={fetchEmailPreview}
                    backgroundColor="#6860ee"
                    color="#FFFFFF"
                    disabled={!canPreview || emailPreviewData.isLoading}
                    {...(!canPreview && {
                      hoverd: false,
                      hoverStyles: {},
                      hoverIconSrc: null,
                      style: {
                        backgroundColor: "var(--disabled-button)",
                        color: "white",
                        cursor: "not-allowed",
                        opacity: 0.7,
                      },
                    })}
                  />
                </span>
              </CustomTooltip>
              <CustomTooltip
                title={
                  !canPreview
                    ? ""
                    : getMonthlyEmailTooltip("Send reach out email")
                }
                arrow
              >
                <span>
                  <Button
                    label={
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "8px",
                        }}
                      >
                        <img
                          src={SendJobBlastIcon}
                          alt=""
                          style={{ width: "20px" }}
                        />
                        <span>Send Email</span>
                      </div>
                    }
                    event={reachOutFormik.handleSubmit}
                    disabled={!canPreview || isMonthlyEmailLimitReached}
                    {...((!canPreview || isMonthlyEmailLimitReached) && {
                      hoverd: false,
                      hoverStyles: {},
                      hoverIconSrc: null,
                      style: {
                        backgroundColor: "var(--disabled-button)",
                        color: "white",
                        cursor: "not-allowed",
                        opacity: 0.7,
                      },
                    })}
                  />
                </span>
              </CustomTooltip>
            </div>
          </div>
        </StandardPopup>
        {ReactDOM.createPortal(
          <StandardPopup
            isOpen={isEmailPreviewOpen}
            onClose={() => setIsEmailPreviewOpen(false)}
            title="Email Preview"
            hideActions={true}
            width="900px"
            maxHeight="95vh"
            popupStyle={{
              overflow: "hidden",
              display: "flex",
              flexDirection: "column",
            }}
            contentStyle={{
              padding: 0,
              marginTop: 0,
            }}
          >
            <div
              style={{
                overflow: "hidden",
              }}
            >
              <EmailPreviewPopup htmlContent={emailPreviewData.body} />
            </div>
          </StandardPopup>,
          document.body,
        )}
      </div>
    );
  },
);

export default CandidateDetailsContainer;